export default "__VITE_ASSET__B5FHuky2__"